import './ArticleAdvertisement.scss';

export default function Advertisement(props) {
  const { creativeUrl, creativeTextHTML, targetUrl } = props.ads[0];

  return (
    <section id="article_advertisement">
      <p>Partner</p>

      <a
        target="_blank"
        href={targetUrl}
        rel="noopener noreferrer">
        <div id="advertisement_image">
          <img alt="advertisement-image" src={creativeUrl} />
        </div>

        <div
          id="advertisement_text"
          dangerouslySetInnerHTML={{ __html: creativeTextHTML }}
        />
      </a>
    </section>
  );
}
